import { useEffect, useState } from 'react';
import { useMousePosition } from '../../hooks/useMousePosition';

export default function FloatingCard({ children, className = '', delay = 0, intensity = 1 }) {
  const mouse = useMousePosition();
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let raf;
    const loop = () => {
      setTick(Date.now());
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  const bob = Math.sin(tick / 2000 + delay) * 6;

  return (
    <div
      className={`relative ${className}`}
      style={{
        transform: `translateY(${bob}px) translateX(${mouse.x * 8 * intensity}px) rotateX(${mouse.y * -4 * intensity}deg) rotateY(${mouse.x * 4 * intensity}deg)`,
        transformStyle: 'preserve-3d',
        perspective: '1000px',
        transition: 'transform 120ms ease-out',
      }}
    >
      {children}
    </div>
  );
}
